// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

// frontend/src/components/work-optimization/EstimatedEffortBadge.jsx

import React from "react";

function clean(value) {
  const text = String(value ?? "").trim();
  return text || "";
}

function bucketTone(bucket = "") {
  const key = clean(bucket).toLowerCase();
  if (key === "quick") return "ok";
  if (key === "moderate") return "warn";
  if (key === "extended" || key === "large") return "neutral";
  return "neutral";
}

export default function EstimatedEffortBadge({ effort, label, compact = false }) {
  const safeEffort = effort && typeof effort === "object" ? effort : {};
  const display = clean(label) || clean(safeEffort.label) || (safeEffort.minutes ? `${safeEffort.minutes} min` : "Effort —");
  const bucket = clean(safeEffort.bucket) || "unknown";
  const tone = bucketTone(bucket);

  return (
    <span className={`wo-effort-badge wo-effort-${tone} ${compact ? "wo-effort-compact" : ""}`} title={`Estimated operator effort: ${display}`}>
      <span>Effort</span>
      <strong>{display}</strong>
    </span>
  );
}
